import T6v2 from "../../components/ExcerciseTypes/TypeIn/T6v2";
import Circle_Write from "../../components/ExcerciseTypes/Circle_Write";

const json = {
  1: {
    unit: "Unit 2",
    id: "FP8-SB-demo-2023-U2-P29-E12",
    audio: "",
    video: "",
    exerciseKey: "img/FriendsPlus/Page29/E1/key/E1answerkey.png",
    component: T6v2,
    inputSize: 140,
    stylesTextInput: {
      borderStyle: "dotted",
      fontSize: "24px",
      textAlign: "center",
    },
    titleQuestion: [
      {
        num: "1",
        title: `
				Order the words to make questions with
				question tags.
				`,
        color: "rgb(28,190,215)",
        star: 1,
      },
    ],
    textareaStyle: {
      width: 800,
    },
    questionImage: [],
    isHiddenCheck: true,
    questions: [
      {
        title: `
					<div style='width: 700px; display: flex; flex-direction: column; gap: 10px;'>
					damage / don’t they / the environment / cars ?
					<strong style="font-style:italic">Cars damage the environment, don’t they?</strong>
					<span> <strong style="margin-right:30px">1</strong> broke / bottles / didn’t they / those ?</span>
					<textarea id="0" rows=1></textarea>
					<span> <strong style="margin-right:30px">2</strong> recycled / wasn’t it / the rubbish / was ?</span>
					<textarea id="1" rows=1></textarea>
					<span> <strong style="margin-right:30px">3</strong> has he / finished / he hasn’t / the project ?</span>
					<textarea id="2" rows=1></textarea>
					<span> <strong style="margin-right:30px">4</strong> can’t see / from here / you / can you / your flat ?</span>
					<textarea id="3" rows=1></textarea>
					<span> <strong style="margin-right:30px">5</strong> cold / be / it’ll / won’t it / tomorrow ?</span>
					<textarea id="4" rows=1></textarea>
					<span> <strong style="margin-right:30px">6</strong> tired / you’re / aren’t you / feeling ?</span>
					<textarea id="5" rows=1></textarea>
					</div>
        `,
        answer: [
          `Those bottles broke, didn’t they?`,
          `The rubbish was recycled, wasn’t it?`,
          `He hasn’t finished the project, has he?`,
          `You can’t see your flat from here, can you?`,
          `It’ll be cold tomorrow, won’t it?`,
          `You’re feeling tired, aren’t you?`,
        ],
      },
    ],
  },
  2: {
    unit: "Unit 2",
    id: "FP8-SB-demo-2023-U2-P29-E12",
    audio: "",
    video: "",
    exerciseKey: "img/FriendsPlus/Page29/E2/key/E2answerkey.png",
    component: T6v2,
    inputSize: 140,
    stylesTextInput: {
      borderStyle: "dotted",
      fontSize: "24px",
      textAlign: "center",
    },
    titleQuestion: [
      {
        num: "2",
        title: `
				Complete the dialogue with the correct
				words.
				`,
        color: "rgb(28,190,215)",
        star: 2,
      },
    ],
    textareaStyle: {
      width: 800,
    },
    questionImage: [],
    isHiddenCheck: true,
    questions: [
      {
        title: `
					<div style='width: 700px; display: flex; flex-direction: column; gap: 10px;'>
				       <img src="img/FriendsPlus/Page29/E2/1.png" style=""/>
					   
					       <span><strong style="margin-right:30px">Mia</strong>It’s a lovely day today, <strong style="font-style:italic">isn’t</strong> it?</span>
						
						
						   <div style="display:flex;flex-direction:row">
						<strong style="margin-right:28px">Ben</strong>   <span>I suppose so. It’s a lot nicer than last 
						Friday. It was really cold then, (1)#
						it? You remember, (2)# you? 
						I went back home to get a coat!</span>
						 </div> 


						 <div style="display:flex;flex-direction:row">
						 <strong style="margin-right:28px">Mia</strong>   <span>Oh yes, and you lost your keys,
						 (3)# you? How embarrassing!</span>
						  </div> 


						  <div style="display:flex;flex-direction:row">
						  <strong style="margin-right:28px">Ben</strong>   <span>Yes, it (4)# , wasn’t it? I called
						  my dad at work in the end.</span>
						   </div> 

						   <div style="display:flex;flex-direction:row">
						   <strong style="margin-right:28px">Mia</strong>   <span>Oh no! He doesn’t like that, <br/>
						   (5)# he?</span>
							</div> 
							

							<span><strong style="margin-right:30px">Ben</strong>No, he doesn’t!</span>

							<div style="display:flex;flex-direction:row">
							<strong style="margin-right:30px">Mia</strong>   <span>He (6)# angry, was he?</span>
							 </div> 



							 <div style="display:flex;flex-direction:row">
							<strong style="margin-right:30px">Ben</strong>   <span>No, not really. Anyway, I’ve made an <br/>
							extra set of keys. So that won’t happen <br/>
							again, (7)# it?</span>
							 </div> 


							 <span><strong style="margin-right:30px">Mia</strong>No, let’s hope not!
							 </span>
							 



						
						 
					  
					</div>
        `,
        answer: [`wasn’t`, `don’t`, `didn’t`, `was`, `does`, `wasn’t`, `will`],
      },
    ],
  },
  3: {
    unit: "Unit 2",
    id: "FP8-SB-demo-2023-U2-P29-E12",
    audio: "",
    video: "",
    exerciseKey: "img/FriendsPlus/Page29/E3/key/E3answerkey.png",
    component: T6v2,
    inputSize: 200,
    stylesTextInput: {
      borderStyle: "dotted",
      fontSize: "24px",
      textAlign: "center",
    },
    titleQuestion: [
      {
        num: "3",
        title: `
				Correct the words.
				`,
        color: "rgb(28,190,215)",
        star: 2,
      },
    ],
    textareaStyle: {
      width: 800,
    },
    questionImage: [],
    isHiddenCheck: true,
    questions: [
      {
        title: `
					<div style='width: 900px; display: flex; flex-direction: column; gap: 10px;'>
				      <span>This plate is made from recycled materials, <strong style="font-style:italic;text-decoration: line-through;">aren’t 
					  they</strong> ? <strong style="font-style:italic">isn't it</strong></span>


					  <span> <strong style="margin-right:30px">1 </strong> You haven’t heard about this invention, <strong>haven’t
					  you?</strong> #</span>
					  <span> <strong style="margin-right:30px">2 </strong> She isn’t interested in environmental issues, 
					  <strong>does she?</strong> #</span>
					  <span> <strong style="margin-right:30px">3 </strong> He has invented a new smartphone app, <strong>didn’t
					  he?</strong> #</span>
					  <span> <strong style="margin-right:30px">4 </strong> They aren’t going to reduce the price, <strong>, will they? 
					  </strong> #</span>
					  <span> <strong style="margin-right:30px">5 </strong> That company was developing a new type of
					  paper, <strong>was it? </strong> #</span>
					  <span> <strong style="margin-right:30px">6 </strong> You love TV programmes about wildlife,<strong>aren’t
					  you?</strong> #</span>


						
						 
					  
					</div>
        `,
        answer: [
          `have you`,
          `is she`,
          `hasn’t he`,
          `are they`,
          `wasn’t it`,
          `don’t you `,
        ],
      },
    ],
  },
  4: {
    unit: "Unit 2",
    id: "FP8-SB-demo-2023-U2-P29-E12",
    audio: "",
    video: "",
    exerciseKey: "img/FriendsPlus/Page29/E4/key/E4answerkey.png",
    component: T6v2,
    inputSize: 140,
    stylesTextInput: {
      borderStyle: "dotted",
      fontSize: "24px",
      textAlign: "center",
    },
    titleQuestion: [
      {
        num: "4",
        title: `
				Write questions using question tags.
Use the words and your own ideas.
				`,
        color: "rgb(28,190,215)",
        star: 3,
      },
    ],
    textareaStyle: {
      width: 800,
    },
    questionImage: [],
    isHiddenCheck: true,
    questions: [
      {
        title: `
					<div style='width: 700px; display: flex; flex-direction: column; gap: 10px;'>

					<div style='display: flex; flex-direction:column;flex-wrap: wrap; gap: 10px; align-items: center; justify-content: center;
					max-width: 900px; padding: 10px 80px;border-radius: 20px; border: 3px solid rgb(28,190,215);'>
				   
					<div>
					<span>best friend / speak French   &emsp; <span style="text-decoration:line-through">hot / Prague</span></span> 
					</div>
	  
					<div>
					see / this film their parents / not like / swim
					</div>

					<div>
					your holiday / Greece
					</div>
				 
				  
				   
				  </div>
				    <strong style="font-style:italic">It was hot in Prague last weekend, wasn’t it?</strong>


     
					<div  style="display:flex;flex-direction:row">
					<span><strong>1</strong></span> <textarea id="0" rows=1></textarea>
					</div>

					<div  style="display:flex;flex-direction:row">
					<span><strong>2</strong></span> <textarea id="1" rows=1></textarea>
					</div>

					<div  style="display:flex;flex-direction:row">
					<span><strong>3</strong></span> <textarea id="2" rows=1></textarea>
					</div>

					<div  style="display:flex;flex-direction:row">
					<span><strong>4</strong></span> <textarea id="3" rows=1></textarea>
					</div>
				


				       <img src="img/FriendsPlus/Page29/E4/1.png" style=""/>
					   
					  
						
						 
					  
					</div>
        `,
        answer: [
          `His best friend can’t speak French, can she?`,
          `We haven’t seen this film before, have we?`,
          `Their parents don’t like swimming, do they?`,
          `You’re going on holiday to Greece, aren’t you?`,
        ],
      },
    ],
  },
  13: {
    unit: "Unit 2",
    id: "FP8-SB-demo-2023-U2-P29-E13",
    audio: "",
    video: "",
    component: Circle_Write,
    exerciseKey: "img/FriendsPlus/Page29/E13/Key/answerKey.png",
    titleQuestion: [
      {
        num: "",
        title: `
        
				`,
        color: "rgb(29,193,215)",
      },
    ],
    guideModal: [
      // nội dung nút hướng dẫn
      {
        title: "Hướng dẫn",
        description: `
        <span>Em tìm đọc câu chuyện và điền vào phiếu thích hợp. </span><br>
        <video  src="Audios/fpt_ai/guide/p22_e2.mp3" controls style="width: 100%; margin-top:10px; height: 2cm"></video>
            
        `,
      },
    ],
    question: {
      Write: {
        stylesTextInput: { fontSize: "20px", height: 29 },
        answers: [],
        initialValue: [],
      },
      Circle: {
        initialWordStyle: {
          color: "black",
          backgroundColor: "transparent",
          padding: 9,
          // border: "2px solid gray",
          fontWeight: "bold",
          fontSize: 28,

          // marginInline: '-1px',
        },
        selectWordStyle: {
          color: "rgb(255,214,0)",
          fontWeight: 800,
          // backgroundColor: "yellow",
          // border: "2px solid yellow",
          padding: 9,
        },
        limitSelect: 5,
        listWordsStyle: {},
        listWords: [`✓ ✓ ✓ ✓ ✓`],
        answers: ["0-0", "1-8", "2-4", "3-4", "4-0", "5-0"],
        initialValue: [],
      },
      Layout: `
      <div style='position: relative'>
      <img src='/img/FriendsPlus/Page22/E1/1.jpg' style='height:15mm; height: 17mm; margin-left: -206px' />
      <div style='font-weight:bold;position:absolute;top:7px; left:37px;font-size:30px;color:rgb(32 62 111); margin-left: -206px'>ĐỌC MỞ RỘNG</div>
        <div style='width:20cm;margin:20px 0px'>
         
          <div>
            <b style='color:rgb(3, 103, 181); margin-left: -200px'>2.</b>&ensp;Viết phiếu đọc sách theo mẫu.<br>
            
          </div>
          <div style='position: relative; display: flex; flex-direction: column; width: max-content; margin-left: -150px'>
      <div style="text-align: center; background-color: rgb(55,183,236); border: 2px solid black; display: table-caption;">
      PHIẾU ĐỌC SÁCH
      </div>
      <div style='display: flex'>
        <div style="border-left: 2px solid black; border-right: 2px solid black; padding-left: 15px;  padding: 10px"><div>Tên câu chuyện:</div> <input id='0' width='650px'></input></div>
        <div style="padding-left: 15px;  padding: 10px">Tác giả:<br> <input id='1' width='300px'></input></div>
        <div style="border-right: 2px solid black; border-left: 2px solid black;  padding-left: 15px;  padding: 10px">Ngày đọc:<br> <input id='2' width='200px'></input></div>

      </div>     
      <div style="border: 2px solid black; padding-left: 15px; padding: 10px;">
        Tên nhân vật:<input id='3' width='1022px'></input>
      </div>
      <div style="border: 2px solid black; border-top:none; padding-left: 15px; padding: 10px;">
        <span>Năng khiếu nổi bậc của nhân vật:</span> <input id='4' width='800px'></input>
        
      </div>
      <div style="border: 2px solid black; border-top:none;  padding-left: 15px; padding: 10px;">
      Mức độ yêu thích:
      </div>
        
      </div>              
         
        </div>
       
        </div>



      <div style='position: absolute; top: 420px; left: 620px'>
      <div style='position: relative; width: max-content; padding: 10px'>
      <div style='display: flex; width: max-content;'>
      <img src='img/FriendsPlus/Page22/star.png' style='width: 1.2cm; height: 1.2cm' />
      <img src='img/FriendsPlus/Page22/star.png' style='width: 1.2cm; height: 1.2cm' />
      <img src='img/FriendsPlus/Page22/star.png' style='width: 1.2cm; height: 1.2cm' />
      <img src='img/FriendsPlus/Page22/star.png' style='width: 1.2cm; height: 1.2cm' />
      <img src='img/FriendsPlus/Page22/star.png' style='width: 1.2cm; height: 1.2cm' />
      </div>
      
				<div style='position: absolute; top: 10px; left: 14px'><input id='0' type='Circle'/></div>

			</div>
      </div>
			
			  `,
    },
  },

  // 2: {
  //   unit: "Unit Starter",
  //   id: "FP8-WB-demo-2023-US-P5-E1",
  //   audio: "Audios/fpt_ai/p22_e2.mp3",
  //   autoPlay: true,
  //   video: "",
  //   // recorder: true,
  //   exerciseKey: "/img/FriendsPlus/Page22/Key/E2answerKey.png",
  //   component: T6,

  //   inputSize: 81,
  //   stylesTextInput: { fontSize: "20px", height: 29 },
  //   textareaStyle: { width: 1000 },
  //   titleQuestion: [
  //     {
  //       num: "",
  //       title: `

  // 			`,
  //       color: "rgb(29,193,215)",
  //     },
  //   ],
  //   guideModal: [
  //     // nội dung nút hướng dẫn
  //     {
  //       title: "Hướng dẫn",
  //       description: `
  //       <span>Em tìm đọc câu chuyện và điền vào phiếu thích hợp. </span><br>
  //       <video  src="Audios/fpt_ai/guide/p22_e2.mp3" controls style="width: 100%; margin-top:10px; height: 2cm"></video>

  //       `,
  //     },
  //   ],
  //   questionImage: [],
  //   // hideBtnFooter: true,
  //   isHiddenCheck: true,
  //   // isEssay: true,
  //   questions: [
  //     {
  //       title: `
  //       <div style='position: relative'>
  //       <img src='/img/FriendsPlus/Page22/E1/1.jpg' style='height:15mm; height: 17mm; margin-left: -206px' />
  //       <div style='font-weight:bold;position:absolute;top:7px; left:37px;font-size:30px;color:rgb(32 62 111); margin-left: -206px'>ĐỌC MỞ RỘNG</div>
  //         <div style='width:20cm;margin:20px 0px'>

  //           <div>
  //             <b style='color:rgb(3, 103, 181); margin-left: -200px'>2.</b>&ensp;Viết phiếu đọc sách theo mẫu.<br>

  //           </div>
  //           <div style='position: relative; display: flex; flex-direction: column; width: max-content; margin-left: -150px'>
  //       <div style="text-align: center; background-color: rgb(55,183,236); border: 2px solid black; display: table-caption;">
  //       PHIẾU ĐỌC SÁCH
  //       </div>
  //       <div style='display: flex'>
  //         <div style="border-left: 2px solid black; border-right: 2px solid black; padding-left: 15px;  padding: 10px"><div>Tên câu chuyện:</div> <input id='0' width='550px'></input></div>
  //         <div style="padding-left: 15px;  padding: 10px">Tác giả:<br> <input id='1' width='300px'></input></div>
  //         <div style="border-right: 2px solid black; border-left: 2px solid black;  padding-left: 15px;  padding: 10px">Ngày đọc:<br> <input id='2' width='200px'></input></div>

  //       </div>
  //       <div style="border: 2px solid black; padding-left: 15px; padding: 10px;">
  //         Tên nhân vật:<br> <textarea id='3' rows='2'>
  //       </div>
  //       <div style="border: 2px solid black; border-top:none; padding-left: 15px; padding: 10px;">
  //         <span>Năng khiếu nổi bậc của nhân vật:</span> <br>
  //         <textarea id='4' rows='3'>
  //       </div>
  //       <div style="border: 2px solid black; border-top:none;  padding-left: 15px; padding: 10px;">
  //       Mức độ yêu thích: <span style=''>★ ★ ★ ★ ★</span>
  //       </div>

  //       </div>

  //         </div>

  //         </div>
  //       `,
  //       answer: ["", "", "", "", ""],
  //     },
  //   ],
  // },
  14: {
    unit: "Unit 2",
    id: "FP8-SB-demo-2023-U2-P29-E12",
    audio: "",
    video: "",
    exerciseKey: "img/FriendsPlus/Page29/E14/Key/answerKey.png",
    component: T6v2,
    hintBox: [
      {
        src: [
          `absolutel`,
          `one of the most`,
          `quite an`,
          `really delicious`,
          `to seeing`,
          `to`,
          `stop`,
          `very`,
          `visiting`,
        ],
        borderColor: "rgb(110, 110, 112)",
        width: 480,
      },
    ],
    inputSize: 200,
    stylesTextInput: {
      borderStyle: "dotted",
      fontSize: "24px",
      textAlign: "center",
    },
    titleQuestion: [
      {
        num: "14",
        title: `
					Read the advert and complete the text with the words.
				`,
        color: "rgb(78, 59, 151)",
      },
    ],
    questionImage: [],
    isHiddenCheck: true,
    questions: [
      {
        title: `
					<hintBox id='0'></hintBox>
					<div style='margin-top: 20px;'><img src='img/FriendsPlus/Page29/E14/1.jpg' width='50%' /></div>
					<div style='margin-top: 10px; width: 1000px; padding: 20px; border: 1px solid rgb(110, 110, 112); box-shadow: 7px 7px 5px rgb(110, 110, 112);'>
						<div style='font-weight: bold;'>St Nicholas Market</div>
						<div>
						My favourite place in Bristol is St Nicholas Market. 
						It’s <sup>1</sup> # amazing markets in Britain, and 
						you can almost feel its long history. It’s definitely 
						worth <sup>2</sup> # . When you enter, you see 
						hundreds of colourful products, from vintage 
						clothes and jewellery to local arts and crafts. You can 
						smell <sup>3</sup> # street food like Indian curry or 
						Algerian falafel. I love walking between the stalls, 
						watching people and seeing what they buy. It’s 
						<sup>4</sup> # experience. But what makes this place 
						really special is an <sup>5</sup> # wonderful glass 
						roof over the stalls. 
						If you ever come to Bristol, don’t forget <sup>6</sup> # 
						by at St Nicholas Market and have lunch. Take time 
						to look for souvenirs (or up at the sky) with a cup 
						of <sup>7</sup> # good coffee in your hand. We’re 
						looking forward <sup>8</sup> # you there.
						</div>
					</div>
        `,
        answer: [
          `one of the most`,
          `visiting`,
          `really delicious`,
          `quite an`,
          `absolutely`,
          `to stop`,
          `very`,
          `to seeing`,
        ],
      },
    ],
  },
};

export default json;
